import { Link, LinkDocument, LinkWeb } from '../schema/prismic/fields/link';

export enum CommonSliceType {
  SUBTITLE = 'subtitle',
  CHAPEAU = 'chapeau',
  HEADING = 'heading',
  TEXT = 'text',
  QUOTE = 'quote',
  LIST = 'list',
  FAQ = 'faq',
  INSERT = 'insert',
  HIGHLIGHTED = 'highlighted',
  FOOTNOTE = 'footnote',
  KEY_FIGURE_3 = 'key-figures-3',
  KEY_FIGURE = 'key-figure',
  CHILD_PUSHS = 'child_pushs',
  COLD_PUSH = 'cold_push',
  IMAGE_N_CAPTION = 'image',
  VIDEO_N_CAPTION = 'video',
  AUDIO_N_CAPTION = 'audio',
  IMAGE_N_TXT = 'image-text',
  VIDEO_N_TXT = 'video-text',
  AUDIO_N_TXT = 'audio-text',
  IMAGE_N_QUOTE = 'image-quote',
  VIDEO_N_QUOTE = 'video-quote',
  AUDIO_N_QUOTE = 'audio-quote',
  DOWNLOAD_LINK = 'download-link',
  CTA_LINK = 'cta-link',
  SOCIAL_MEDIA = 'social-media',
  CONTACT = 'contact',
  COVER_CAROUSEL = 'cover-carousel',
  INTERNAL_MEDIA = 'internal-media',
  MAP = 'map',
  QUIZ = 'quiz',
}

enum _PostmenSliceType {
  POSTMEN_TITLE = 'postmen-title',
  STAFF_ILLUSTRATION = 'staff-illustration',
  QUOTES = 'quotes',
  PARITY_ILLUSTRATION = 'parity-illustration',
  TXT_ILLUSTRATIONS = 'txt-illustrations',
}

export type PostmenSliceType = CommonSliceType | _PostmenSliceType;
export const PostmenSliceType = {
  ...CommonSliceType,
  ..._PostmenSliceType,
};

enum _PublicServiceMissionsSliceType {
  TIMELINE = 'timeline',
  PRINCIPLES = 'principles',
}

export type PublicServiceMissionsSliceType =
  | CommonSliceType
  | _PublicServiceMissionsSliceType;
export const PublicServiceMissionsSliceType = {
  ...CommonSliceType,
  ..._PublicServiceMissionsSliceType,
};

enum _InnovationByLaPosteSliceType {
  ILLUSTRATION = 'illustration',
  TEXT_WITH_ILLUSTRATION = 'text-with-illustration',
}

export type InnovationByLaPosteSliceType =
  | CommonSliceType
  | _InnovationByLaPosteSliceType;
export const InnovationByLaPosteSliceType = {
  ...CommonSliceType,
  ..._InnovationByLaPosteSliceType,
};

export enum HomeSliceType {
  SLIDER_HERO = 'slider-hero',
  VIDEO_HERO = 'video-hero',
  OUR_NEWS = 'our-news',
  FEATURED_POSTS = 'features-posts',
  SELECTED_POSTS = 'selected-posts',
  TWITTER_CAROUSEL = 'twitter-carousel',
  PUBLICATIONS = 'publications',
}

export type Slice = {
  type: string;
};

export type HomeTile = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  image?: any;
  title?: string;
  subtitle?: string;
  ctaLabel?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ctaLink?: any;
};

export type SliderHeroSlide = HomeTile;
export type SliderHeroSlice = Slice & {
  slides: SliderHeroSlide[];
};

export enum VideoType {
  YOUTUBE = 'Youtube',
  LIBCAST = 'Libcast',
}

export type VideoHeroSlice = Slice & {
  title: string;
  description: string;
  videoLink: LinkWeb;
  videoType: VideoType;
  ctaLabel: string | void;
  ctaLink: Link;
  ctaTranscriptionLabel: string | void;
  ctaTranscriptionLink: Link;
};

export type OurNewsSlice = Slice & {
  title: string;
  nbTiles: number;
};

export type FeaturedPostsSlice = Slice & {
  title: string;
  subtitle?: string;
  ctaLabel?: string;
  ctaLink?: Link;
  tiles: FeaturedPostsTile[];
};
export type FeaturedPostsTile = HomeTile;

export type SelectedPostsSlice = Slice & {
  title: string;
  tiles: SelectedPostsTile[];
};

export type PublicationsSliceTile = {
  title: string;
  date: number;
  relatedMedia: LinkDocument;
};

export type PublicationsSlice = Slice & {
  title: string;
  ctaLabel: string;
  ctaLink: Link;
  tiles: PublicationsSliceTile[];
};

export type SelectedPostsTile = HomeTile;

export type TwitterCarouselSlice = Slice & {
  list: string;
};
